import { render, staticRenderFns } from "./TurkUluslararasiGemiSicilineKayitliGemilerForm.vue?vue&type=template&id=487f27c0&scoped=true"
import script from "./TurkUluslararasiGemiSicilineKayitliGemilerForm.vue?vue&type=script&lang=ts"
export * from "./TurkUluslararasiGemiSicilineKayitliGemilerForm.vue?vue&type=script&lang=ts"
import style0 from "./TurkUluslararasiGemiSicilineKayitliGemilerForm.vue?vue&type=style&index=0&id=487f27c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f27c0",
  null
  
)

export default component.exports